import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    useEffect(() => {
        fetch();
    },[]);
    const [data, setData] = useState([]);
    const fetch = async () => {
        const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/categories_get`);
        setData(res.data);
    };
    return (
        <div>
            <div className="footer container-fluid position-relative bg-dark py-5" style={{ marginTop: 90 }}>
                <div className="container pt-5">
                    <div className="row">
                        <div className="col-lg-6 pr-lg-5 mb-5">
                            <a href="index.html" className="navbar-brand">
                                <h1 className="mb-3 text-white"><span className="text-primary">Rajvi</span> Cosmetic Clinic</h1>
                            </a>
                            <p> A state of the art multispeciality skin & cosmetic clinic promising world-class treatments done by highly specialized professionals in environs that assure optimum care and comfort for each of their clients is what defines Rajvi Cosmetic Clinic.
                            </p>
                            <p><i className="fa fa-map-marker-alt mr-2" />411,412, Signature Arcade, Nr. Gangotri Circle, Nikol, Ahmedabad, Gujarat, India - 382350 </p>
                            <p><i className="fa fa-phone-alt mr-2" />+91 9106856105</p>
                            <p><i className="fa fa-envelope mr-2" />support@rajvicosmeticclinic.com</p>
                            <div className="d-flex justify-content-start mt-4">
                                <a className="btn btn-lg btn-primary btn-lg-square mr-2" href="https://www.facebook.com/profile.php?id=100093401964815"><i className="fab fa-facebook-f" /></a>
                                <a className="btn btn-lg btn-primary btn-lg-square" href="https://www.instagram.com/rajvicosmeticclinic"><i className="fab fa-instagram" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 pl-lg-5">
                            <div className="row">
                                <div className="col-sm-6 mb-5">
                                    <h5 className="text-white text-uppercase mb-4">Quick Links</h5>
                                    <div className="d-flex flex-column justify-content-start">
                                        <Link className="text-white-50 mb-2" to="/"><i className="fa fa-angle-right mr-2" />Home</Link>
                                        <Link className="text-white-50 mb-2" to="/about"><i className="fa fa-angle-right mr-2" />About Us</Link>
                                        <Link className="text-white-50 mb-2" to="/services"><i className="fa fa-angle-right mr-2" />Our Services</Link>
                                        <Link className="text-white-50 mb-2" to="/blog"><i className="fa fa-angle-right mr-2" />Blog</Link>
                                        <Link className="text-white-50" to="/contact"><i className="fa fa-angle-right mr-2" />Contact Us</Link>
                                        <Link className="text-white-50 mb-2" to="/login"><i className="fa fa-angle-right mr-2" />Login</Link>
                                    </div>
                                </div>
                                <div className="col-sm-6 mb-5">
                                    <h5 className="text-white text-uppercase mb-4">Our Services</h5>
                                    <div className="d-flex flex-column justify-content-start">
                                        {
                                            (data.length > 0) ?
                                                data.map((value) => {
                                                    return (
                                                        <Link className="text-white-50 mb-2" to={"/services_details/" + value.id}><i className="fa fa-angle-right mr-2" />{value.cate_name}</Link>
                                                    );
                                                })
                                                : null
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid bg-dark text-light border-top py-4" style={{ borderColor: 'rgba(256, 256, 256, .15) !important' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-left mb-3 mb-md-0">
                            <p className="m-0 text-white">Rajvi Cosmetic Clicinc© <a href="#"> Center </a>. All Rights Reserved.</p>
                        </div>
                        <div className="col-md-6 text-center text-md-right">
                            <p className="m-0 text-white">Designed by <a href="#">Nagar & Com.</a></p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer End */}
            {/* Back to Top */}
            <a href="#" className="btn btn-lg btn-primary back-to-top"><i className="fa fa-angle-double-up" /></a>


        </div>

    )
}

export default Footer